module.exports = __webpack_public_path__ + "static/mobile-banner-video-a0e94f0d6a74dfeee62172e02902b923.mp4";